export type PriceDisplay = {
  basePrice: number;
  finalPrice: number;
  hasDiscount: boolean;
};

export const getDiscountedPrice = (
  basePrice: number,
  salePercent?: number | null
): PriceDisplay => {
  const normalizedSale =
    typeof salePercent === 'number' && Number.isFinite(salePercent)
      ? Math.max(0, salePercent)
      : 0;
  const hasDiscount = normalizedSale > 0;
  const finalPrice = hasDiscount
    ? basePrice * (1 - normalizedSale / 100)
    : basePrice;

  return {
    basePrice,
    finalPrice,
    hasDiscount,
  };
};
